// extracted by mini-css-extract-plugin
export default {"link":"Demo_link__2ryi9"};